export function selectInstanceConfig<TType>(
    appState: Spintr.AppState,
    key: string | number | symbol,
): TType {
    return appState.instance.get(key) as TType;
}

